import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCornerRadius: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCornerRadius"><Path d="M21 3.5H3.5V21" stroke="currentColor"/></CentralIconBase>;
});

export default IconCornerRadius;
